module.exports = __webpack_public_path__ + "img/logo.dded50e1.png";